import { Component, Input, ViewChild, SimpleChanges } from '@angular/core';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { EmailSubscriptionLogDto } from '../../shared/email-subscription-log.dto';
import { EmailSubscriptionSearchDto } from '../../shared/email-subscription-search';
import { DatagridService, PagedResultGeneric, TranslationService } from 'src/app/shared';
import { CommunicationService } from '../../shared/communication.service';
import { timeoutWrapper } from 'src/app/shared/decorator/timeout-wrapper';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
  selector: 'wl-mass-comm-subscription-tracking',
  templateUrl: './mass-comm-subscription-tracking.component.html',
  styleUrl: './mass-comm-subscription-tracking.component.less',
    standalone: false
})
export class MassCommSubscriptionTrackingComponent extends LazySelectableTableComponent<
  EmailSubscriptionSearchDto,
  EmailSubscriptionLogDto
> {
  @Input() startDate: Date;
  @Input() endDate: Date;
  @ViewChild(Table) _dataTable: Table;

  statusDropDownOptions = new Array<SelectItem>();

  constructor(
    datagridService: DatagridService,
    private _communicationService: CommunicationService,
    private _navigationService: NavigationService,
    private _translationService: TranslationService
  ) {
    super('AuditId', datagridService);
    this.searchParams = {
      StartDate: this.startDate,
      EndDate: this.endDate,
      PageNumber: 1,
      PageSize: 20,
      OrderBy: 'AuditDate:desc',
    };

    this.statusDropDownOptions = [
      { label: this._translationService.getInstantTitlecase('profiles.search.advanced.options.opted-in'), value: true },
      { label: this._translationService.getInstantTitlecase('profiles.search.advanced.options.opted-out'), value: false },
    ];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.startDate || changes.endDate) {
      this.search();
    }
  }

  fetchResults(): Promise<PagedResultGeneric<EmailSubscriptionLogDto>> {
    const optedInFilter = this._dataTable.filters['OptedIn'];

    this.searchParams.OptedIn = Array.isArray(optedInFilter) ? optedInFilter[0]?.value : optedInFilter?.value;
    this.searchParams.StartDate = this.startDate;
    this.searchParams.EndDate = this.endDate;
    return this._communicationService.searchEmailSubscriptionLogs(this.searchParams);
  }

  navigateToProfile(profileId: number) {
    this._navigationService.navigateToProfileView(profileId);
  }
}
